export const LIST_MCU_PROJECT_PATIENT_BATCH_REQUEST = 'LIST_MCU_PROJECT_PATIENT_BATCH_REQUEST'
export const LIST_MCU_PROJECT_PATIENT_BATCH_SUCCESS = 'LIST_MCU_PROJECT_PATIENT_BATCH_SUCCESS'
export const LIST_MCU_PROJECT_PATIENT_BATCH_FAIL = 'LIST_MCU_PROJECT_PATIENT_BATCH_FAIL'

export const LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_FAIL = 'LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_FAIL'

export const LIST_MCU_PROJECT_PERIOD_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_PERIOD_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_PERIOD_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_PERIOD_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_PERIOD_SUMMARY_FAIL = 'LIST_MCU_PROJECT_PERIOD_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_PATIENT_BATCH_REQUEST = 'CREATE_MCU_PROJECT_PATIENT_BATCH_REQUEST'
export const CREATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS = 'CREATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS'
export const CREATE_MCU_PROJECT_PATIENT_BATCH_FAIL = 'CREATE_MCU_PROJECT_PATIENT_BATCH_FAIL'

export const DETAIL_MCU_PROJECT_PATIENT_BATCH_REQUEST = 'DETAIL_MCU_PROJECT_PATIENT_BATCH_REQUEST'
export const DETAIL_MCU_PROJECT_PATIENT_BATCH_SUCCESS = 'DETAIL_MCU_PROJECT_PATIENT_BATCH_SUCCESS'
export const DETAIL_MCU_PROJECT_PATIENT_BATCH_FAIL = 'DETAIL_MCU_PROJECT_PATIENT_BATCH_FAIL'

export const UPDATE_MCU_PROJECT_PATIENT_BATCH_REQUEST = 'UPDATE_MCU_PROJECT_PATIENT_BATCH_REQUEST'
export const UPDATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS = 'UPDATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS'
export const UPDATE_MCU_PROJECT_PATIENT_BATCH_FAIL = 'UPDATE_MCU_PROJECT_PATIENT_BATCH_FAIL'

export const DELETE_MCU_PROJECT_PATIENT_BATCH_REQUEST = 'DELETE_MCU_PROJECT_PATIENT_BATCH_REQUEST'
export const DELETE_MCU_PROJECT_PATIENT_BATCH_SUCCESS = 'DELETE_MCU_PROJECT_PATIENT_BATCH_SUCCESS'
export const DELETE_MCU_PROJECT_PATIENT_BATCH_FAIL = 'DELETE_MCU_PROJECT_PATIENT_BATCH_FAIL'

export const RESET_MCU_PROJECT_PATIENT_BATCH = 'RESET_MCU_PROJECT_PATIENT_BATCH'
